import OutdoorLightingIcon from './component'

export default OutdoorLightingIcon
